'use client';

import { type components } from '~/fecom-api/schema';
import { Price } from './price';
import { cn } from '~/lib/utils';

export type ProductPriceBreaksProps = {
  priceBreaks: components['schemas']['ProductPriceBreak'][];
  onPriceBreakClick?: (quantity: number) => void;
  disabled: boolean;
};

export function ProductPriceBreaks({
  priceBreaks,
  onPriceBreakClick,
  disabled,
}: ProductPriceBreaksProps) {
  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-lg font-semibold lg:hidden">Buy more, save more!</h3>
      <div className={cn('grid grid-cols-1 gap-2 lg:grid-cols-3 lg:gap-6')}>
        {priceBreaks.map((priceBreak, index) => (
          <PriceBreak
            disabled={disabled}
            key={index}
            priceBreak={priceBreak}
            onPriceBreakClick={onPriceBreakClick}
          />
        ))}
      </div>
    </div>
  );
}

type PriceBreakProps = {
  priceBreak: components['schemas']['ProductPriceBreak'];
  onPriceBreakClick?: (quantity: number) => void;
  disabled: boolean;
};

function PriceBreak({
  disabled,
  priceBreak,
  onPriceBreakClick,
}: PriceBreakProps) {
  return (
    <button
      disabled={disabled}
      onClick={() => {
        onPriceBreakClick?.(priceBreak.units);
      }}
      className={cn(
        'price-break',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'col-span-1 flex h-auto overflow-hidden transition-opacity duration-200 hover:opacity-90 lg:flex-col',
      )}
    >
      <div className="price-break__quantity-section flex w-full flex-col items-center justify-center gap-1 text-center">
        <p className="text-[23px] font-bold leading-none">
          Buy {priceBreak.units}+
        </p>
        <p className="!text-[20px] text-lg leading-none">
          {`Save ${Math.floor(priceBreak.savingsPercentage)}%`}
        </p>
      </div>
      <div className="price-break__price-section flex w-full flex-col items-center justify-center gap-1 py-4 text-center leading-none">
        <p className="!text-[16px] text-xl font-bold leading-none">
          <Price
            priceExcVat={priceBreak.price}
            priceIncVat={priceBreak.priceIncVat}
          />{' '}
          each exc. VAT
        </p>
      </div>
    </button>
  );
}
